import { ToolbarOptions } from "./interfaces/toolBar.interface";
import { DPUViewer } from "./DPUViewer";
import { ValidToken } from "./utils/Dialog/validToken";
import { setLanguage } from "./language";
import { DPULoading } from "./services/Loading/loading";


export class DPUService {
    private _dpuLoading: DPULoading | undefined
    /**
     * Khởi tạo giao diện với container, token, tùy chọn thanh công cụ và ngôn ngữ được chỉ định.
     *
     * @param containerId - ID của container nơi giao diện sẽ được khởi tạo.
     * @param token - Token xác thực cần thiết để khởi tạo.
     * @param inputOptionToolBar - (Tùy chọn) Cấu hình cho thanh công cụ.
     * @param language - Ngôn ngữ được thiết lập cho giao diện. Mặc định là 'vn' (Tiếng Việt).
     * @returns Một promise trả về khi quá trình khởi tạo hoàn tất.
     */
    initView = async (containerId: string, token: string, inputOptionToolBar?: ToolbarOptions, language: string = 'vn') => {
        this._dpuLoading = new DPULoading(containerId)
        setLanguage(language);
        return await this._initCheckToken(containerId, token, inputOptionToolBar); // Thêm return
    }

    private _checkToken = async (containerId: string, token: string) => {
        const apiUrl = `https://translateservicedev.corebim.com/authApi/System/ValidateToken`;

        try {
            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    "accept": "*/*",
                    "Authorization": `Bearer ${token}`,
                },
            });
            return response.ok;
        } catch (error) {
            new ValidToken(containerId)
            console.error("Lỗi khi kiểm tra token:", error);
            return false;
        }
    }

    private _initCheckToken = async (containerId: string, token: string, inputOptionToolBar?: ToolbarOptions) => {


        const isValidToken = await this._checkToken(containerId, token);
        if (this._dpuLoading) {
            this._dpuLoading!.destroyLogo()
            this._dpuLoading = undefined
        }
        if (isValidToken) {
            const dpuView = new DPUViewer(containerId, token, inputOptionToolBar);

            return dpuView; // Trả về dpuView nếu token hợp lệ
        } else {
            console.error("Token không hợp lệ");


            return null; // Trả về null nếu token không hợp lệ
        }

    };


    /**
     * Hàm load CSS cho Cesium Js,React
     * 
     */
    loadBaseUrl = () => {
        (window as any).CESIUM_BASE_URL = 'https://unpkg.com/beta-test-view@0.0.10/dist/cesiumStatic';

        // Kiểm tra nếu stylesheet chưa được thêm
        if (!document.querySelector('link[href="https://cesium.com/downloads/cesiumjs/releases/1.125/Build/Cesium/Widgets/widgets.css"]')) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = "https://cesium.com/downloads/cesiumjs/releases/1.125/Build/Cesium/Widgets/widgets.css";
            document.head.appendChild(link);
        }
    }

    initViewWithoutUrl = (containerId: string, token: string, inputOptionToolBar?: ToolbarOptions, language: string = 'vn') => {
        setLanguage(language);
        this._dpuLoading = new DPULoading(containerId)
        const dpuView = new DPUViewer(containerId, token, inputOptionToolBar);
        if (this._dpuLoading) {
            this._dpuLoading!.destroyLogo()
            this._dpuLoading = undefined
        }
        return dpuView
    }
}